/*
BESCHRIJVING:
Een block dat een video of afbeelding laat zien naast een tekst met titel en subtitel. 
De gebruiker kan kiezen of de media op mobile ook te zien moet zijn, als dat zo is komt die boven de tekst te staan.

De media bewaart altijd zijn oorspronkelijke aspect ratio, wordt niet gecropt, en wordt nooit groter dan zijn oorspronkelijke formaat.

DATA:
{
  title: string
  subtitle: string
  text: html string
  textAlign: 'start' | 'center' | 'end'
  mediaFormat: 'video' | 'image'
  video: string (video ID)
  image: string (image ID)
  switchOrder: boolean (Media verschijnt rechts ipv links van tekst if true)
  showMediaOnMobile: boolean
  buttons: CTA Input group - default: {buttonlink: Link, buttonColor1: color, buttonColor2: color}

}
*/

import React, {
  ChangeEvent,
  FormEvent,
  useContext,
  useRef,
  useState,
} from "react"
import { getItemFromId } from "@rubendenbrok/bloqmatter-cms"
import getCascadingColor from "../../functions/getCascadingColor"
import H3 from "../atoms/H3"
import H2 from "../atoms/H2"
import TextBasic from "../atoms/TextBasic"

import { DataContext } from "../Layout"
import BgVideo from "../molecules/BgVideo"
import Button from "../atoms/Button"
import ResponsiveImg from "../molecules/ResponsiveImg"
import useIsInScreen from "../../hooks/useIsInScreen"
import { fadeSlideIn } from "../../styles/animations"
import { DEFAULT_BLOCKOPTIONS_DEFAULTS } from "@rubendenbrok/bloqmatter-cms"
import HoverLines from "../atoms/HoverLines"
import GatsbyLink from "gatsby-link"

type props = any

export default function ShowsListBlock_Display({ blockContent, index }: props) {
  const {
    cssVariables,
    thisPage,
    siteOverviewData,
    videoData,
    processedImageData,
  } = useContext(DataContext)
  const videoObj = getItemFromId(blockContent.video, videoData)
  const [inputVal, setInputVal] = useState("")
  const [inputXVal, setInputXVal] = useState("")

  const formRef = useRef<HTMLFormElement | null>(null)

  const imgObj = getItemFromId(blockContent.image, processedImageData)

  const [animRef, isVisible] = useIsInScreen("100px")
  const scrollAnimation = isVisible ? fadeSlideIn.show : fadeSlideIn.hide

  return (
    <div
      className={`w-full relative flex flex-col justify-center items-center`}
    >
      <div
        ref={animRef}
        className={`w-full  flex flex-col items-start md:items-center md:px-20 px-5 ${
          blockContent.showMediaOnMobile ? "lg:mt-0 mt-6" : ""
        }`}
        style={{
          ...fadeSlideIn.transition,
          ...scrollAnimation,
        }}
      >
        {(blockContent.shows?.length === 0 || !blockContent.shows) && (
          <>
            <div className="font-basic text-lg">New shows coming soon!</div>
            <div className="font-basic text-lg">
              For bookings contact info@rubengerards.com
            </div>
          </>
        )}
        {blockContent.shows.map((show, index) => {
          return (
            <div className="w-full flex mb-4 justify-start">
              <TextBasic
                color={
                  thisPage
                    ? getCascadingColor(
                        cssVariables,
                        siteOverviewData,
                        thisPage,
                        blockContent
                      ).title
                    : "black"
                }
                className={`text-left overflow-y-visible pr-4 w-32`}
              >
                {show.date}
              </TextBasic>

              <TextBasic
                color={
                  thisPage
                    ? getCascadingColor(
                        cssVariables,
                        siteOverviewData,
                        thisPage,
                        blockContent
                      ).title
                    : "black"
                }
                className={`text-left overflow-y-visible w-full`}
              >
                {show.name}
              </TextBasic>
              <a href={show.linkUrl}>
                <TextBasic
                  color={
                    thisPage
                      ? getCascadingColor(
                          cssVariables,
                          siteOverviewData,
                          thisPage,
                          blockContent
                        ).title
                      : "black"
                  }
                  className={`text-left overflow-y-visible cursor-pointer underline`}
                >
                  {show.linkText}
                </TextBasic>
              </a>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export const showsListBlock_Inputs = {
  key: "showsListBlock",
  name: "Shows List Block",
  description: "A block to list upcoming shows.",
  tags: ["Media", "Image", "Video", "Text", "CTA"],
  inputs: [
    {
      inputType: "inputArray",
      label: "Shows",
      itemName: "Show",
      keyName: "shows",
      childInputs: [
        {
          inputType: "text",
          label: "Name",
          keyName: "name",
          defaultVal: "",
        },
        {
          inputType: "text",
          label: "Date",
          keyName: "date",
          defaultVal: "",
        },
        {
          inputType: "text",
          label: "Link target",
          keyName: "linkTarget",
          defaultVal: "",
        },
        {
          inputType: "text",
          label: "Link text",
          keyName: "linkText",
          defaultVal: "",
        },
      ],
    },
  ],
  defaults: {
    ...DEFAULT_BLOCKOPTIONS_DEFAULTS,
  },
}
